<div class="add-inventory-container">
  <div class="page-header-container">
    <div class="header-composed">
      <a routerLink="/inventory/ndc" class="text-title-2 back-ref">
        Inventory
      </a>
      <div class="text-title-2 header">
        Bulk Add
      </div>
    </div>

    <div class="page-subheader">
      <div class="inventory-details">
        Add multiple drugs to your inventory
    </div>
    <!-- <pre>{{(libertyRxLoadInventoryStatus$ | async) | json}}</pre> -->

    </div>
  </div>

  <form class="flex flex-col border-b border-b-color-border" [formGroup]="addInventoryControlsForm">
    <div class="table-controls-container">
      <app-input-search-scanner formControlName="friendlyName"
                                (optionSelected)="optionSelected($event)"
                                [isInventory]="false"
                                [placeholder]="'Scan barcode or search drug name, NDC'"
                                [loading]="isLoading$ | async"
                                [label]="'Add Drug'"
                                [autofocus]="focusDrugSearch"
                                [showLocation]="false"
                                [searchBothCustomAndFdaDrugs]="true"
      ></app-input-search-scanner>
      <app-input (keyupEnter)="addQuantity()"
                formControlName="quantity"
                type="number"
                [maxLength]="10"
                [label]="'Quantity'"
                [autofocus]="focusQuantity"
                (blurred)="focusQuantity = false"
                [showErrors]="false"
      ></app-input>

      <app-button styleClass="settings"
                  subStyle="blue"
                  text="Add"
                  class="add"
                  [minWidth]="0"
                  [disabled]="loading || !this.currentOption"
                  (clicked)="addQuantity()"
      >
      </app-button>

      <div class="load-inventory-transaction-date-container">
        <div class="flex flex-row space-x-4"> 
          <app-button
            text="Load from File"
            class="add"
            customClasses="px-4"
            (clicked)="displayFileUploader = true"
          >
          </app-button>
        </div>
        <app-datepicker-input class="date-picker"
          label="Transaction Date/Time"
          pickerType="both"
          formControlName="transactionDateDisplayValue"
          (dateTimeChange)="dateTimeChanged($event)"
          [dateMax]="now()"
          calendarPosition="right"
          #transactionDatePicker>
        </app-datepicker-input>
      </div>
     
      <div *ngIf="addInventoryControlsForm.get('quantity').dirty && addInventoryControlsForm.get('quantity').value !== '' && +addInventoryControlsForm.get('quantity').value === 0"
          class="error-message">
        Quantity must be greater than 0
      </div>
    </div>
    <div class="enter-order-details-link" *ngIf="ndcList?.length && !collectedOrderDetails" 
      (click)="displayOrderDetailsDialog = true">
      Enter order details
    </div>
    <div class="collected-order-details-container" *ngIf="collectedOrderDetails">
      <div class="detail" *ngIf="collectedOrderDetails?.wholesaler">
        <span class="label">Wholesaler:</span>
        <span class="value">{{collectedOrderDetails.wholesaler.name}}</span>
      </div>
      <div class="detail" *ngIf="collectedOrderDetails?.csos">
        <span class="label">CSOS #:</span>
        <span class="value">{{collectedOrderDetails.csos}}</span>
      </div>
      <div class="detail" *ngIf="collectedOrderDetails?.poNumber">
        <span class="label">PO #:</span>
        <span class="value">{{collectedOrderDetails.poNumber}}</span>
      </div>
      <div class="detail" *ngIf="collectedOrderDetails?.invoiceNumber">
        <span class="label">Invoice #:</span>
        <span class="value">{{collectedOrderDetails.invoiceNumber}}</span>
      </div>
      <div class="detail" *ngIf="collectedOrderDetails?.shipDate">
        <span class="label">Ship Date:</span>
        <span class="value">{{collectedOrderDetails.shipDate | formattedDate: 'MM/dd/yyyy'}}</span>
      </div>

      <app-button subStyle="white"
        text="Edit"
        [minWidth]="55"
        (clicked)="displayOrderDetailsDialog = true"
      ></app-button>
      <app-button subStyle="white"
        text="Remove"
        [minWidth]="90"
        (clicked)="collectedOrderDetails = null"
      ></app-button>
    </div>
    <app-supplier-buyer-sale-details class="block pb-4 px-8" *ngIf="collectedOrderDetails?.buyerDetails"
      [readOnly]="true"
      [supplier]="collectedOrderDetails?.supplierDetails"
      [buyer]="collectedOrderDetails.buyerDetails">
    </app-supplier-buyer-sale-details>

  </form>

  <app-inventory-empty-splash *ngIf="!ndcList.length"
                              [message]="'You haven’t added any drugs to your inventory yet.'"
  ></app-inventory-empty-splash>

  <div *ngIf="ndcList.length" class="table-scroll-wrapper">
    <table class="table-primary inventory-history-table">
      <thead>
      <tr>
        <th (click)="sortByColumn('name')" class="text-left sort drug" scope="col">
          Drug
          <img [class.asc]="tableColumns.name" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th class="text-left location" scope="col" *ngIf="inventoryLocationsEnabled">Into Location</th>
        <th class="text-right starting" scope="col">Starting</th>
        <th class="text-right adding" scope="col">Adding</th>
        <th class="text-right on-hand" scope="col">On-Hand</th>
        <th class="text-right on-hand" scope="col">SOH</th>
        <th class="text-left back-count" scope="col" *ngIf="backCountService.isAnyRequiresBackCount()">
          BACK-COUNT OK?
        </th>
        <th class="text-right controls" scope="col">
          <!-- Controls -->
        </th>
      </tr>
      </thead>
      <tbody [class.withOrder]="collectedOrderDetails?.buyerDetails" cdk-scrollable>
      <tr class="table-row"  *ngFor="let rowData of ndcList; let i = index">
        <td class="text-left drug">
          <div class="heading">
            {{rowData.name}}
          </div>
          <div class="secondary">
            {{rowData.packageNdc}}
          </div>
        </td>
        <ng-container [formGroup]="addInventoryControlsForm">
          <td class="location" formArrayName="locationsAndBackCounts"  *ngIf="inventoryLocationsEnabled">
            <app-inventory-locations-dropdown [formGroupName]="i"
              [formControl]="addInventoryControlsForm.controls?.locationsAndBackCounts?.at(i)?.get('id')"
              [excludeOptions]="excludeOptions[i]"
              (optionChosen)="locationChosen($event, i)"
            >
            </app-inventory-locations-dropdown>
          </td>
        </ng-container>
        <td class="text-right starting">{{rowData.ndcAmount}}</td>
        <td class="text-right adding">
          <ng-container *ngIf="editRow[i]">
            <app-input [textAlign]="'right'"
                       type="number"
                       (keyupEnter)="closeEditMode(i)"
                       [(ngModel)]="addingValues[i]"
                       [autoselect]="editRow[i]"
                       [invalid]="+addingValues[i] <= 0"
            ></app-input>
          </ng-container>
          <ng-container *ngIf="!editRow[i]">
            <span (click)="openEditMode(i)">{{rowData.adding}}</span>
          </ng-container>
        </td>
        <td class="text-right on-hand relative">
          {{rowData.onHand}}
          <app-back-count-not-resolved-tooltip
            [alwaysShow]="rowData?.isUnresolvedBackCountExists"
          ></app-back-count-not-resolved-tooltip>
        </td>
        <td class="text-right on-hand">
          {{rowData.availableSOH}}
        </td>
        <ng-container [formGroup]="addInventoryControlsForm" >
          <td class="text-left back-count" *ngIf="backCountService.isAnyRequiresBackCount()" formArrayName="locationsAndBackCounts" >
            <app-yes-no-toggle [hidden]="!backCountService.isDrugRequiresBackCount(rowData?.id)" [formGroupName]="i"
              [control]="addInventoryControlsForm.controls?.locationsAndBackCounts?.at(i)?.get('isBackCountMatches')"
              (valueChanged)="backCounted($event, rowData.id, rowData.locationId)"
              #backCountToggle
            ></app-yes-no-toggle>
          </td>
        </ng-container>
        <td class="text-right control pr-0">

          <div [hidden]="!editRow[i]">
           

            
            <app-button styleClass="settings"
                        subStyle="blue"
                        class="update"
                        text="Update"
                        [minWidth]="0"
                        customClasses="px-4"
                        (clicked)="closeEditMode(i)"
                        [disabled]="+addingValues[i] <= 0"
            ></app-button>
            <app-button subStyle="white"
                        class="cancel"
                        text="Cancel"
                        [minWidth]="0"
                        customClasses="px-4"
                        (clicked)="closeEditMode(i, false)"
            ></app-button>
            </div>
     
          <div [hidden]="editRow[i]">
            <div class="flex space-x-4 justify-end">
            <app-add-note class="block cursor-pointer z-10"
              [friendlyName]="rowData?.friendlyName"
              [note]="rowData?.note"
              (deleted)="removeNote(rowData.locationId, rowData.id)"
              (submitted)="addNote($event, rowData.locationId, rowData.id)">
            </app-add-note>
                <div class="icon-edit" (click)="openEditMode(i)"></div>
                <div class="delete-icon" (click)="removeNDC(i)"></div>
              </div>
          </div>
          
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="ndcList.length" class="inventory-controls-container">
    <div class="label">
      Adding {{ndcList.length}} NDC{{ndcList.length !== 1 ? 's' : ''}}
    </div>

    <div class="controls" *ngIf="(loadingLibertyRxInventory$ | async) !== (false || null || undefined) || ndcList?.length">
      <app-button subStyle="white"
                  class="cancel-all"
                  text="Cancel All"
                  [disabled]="anyEditModeOpen() || (isLoading$ | async)"
                  (clicked)="cancelAll()"
      ></app-button>

      <app-button [disabled]="anyEditModeOpen() || (isLoading$ | async)"
                  class="add"
                  text="Add {{ndcList.length}} Drug{{ndcList.length !== 1 ? 's' : ''}}"
                  (clicked)="submitClicked()"
      ></app-button>
    </div>
  </div>
</div>

<app-enter-pin-dialog *ngIf="showPinDialog"
                      [show]="showPinDialog"
                      [focusPin]="focusPin"
                      (cancel)="closeDialog()"
                      (setPinHandler)="validatePinRequest($event)"
                      (handleResetPin)="openResetPinDialog()"
></app-enter-pin-dialog>

<app-reset-pin-dialog [show]="showResetPinDialog"
                      (cancel)="closeResetPinDialog()"
                      (afterUpdate)="afterPinUpdated($event)"
></app-reset-pin-dialog>

<app-dialog
  [showHeader]="true"
  [header]="'No New NDCs Found'"
  [minWidth]="500"
  [headerIcon]="'info'"
  [show]="(displayNoNewNdcPopover$ | async)"
  headerCustomClasses="mt-[5px]">
    <div class="flex flex-row-reverse">
        <app-button customClasses="px-4" [text]="'Ok'" class="save-btn" (click)="hideNoNewNdcPopover()" [minWidth]="50">
        </app-button>
    </div>
</app-dialog>

<app-dialog
  [showHeader]="true"
  [header]="'Cannot Load'"
  [subHeader]="'Pharmacy Management System Integration must be configured and enabled from the Settings Page.'"
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'info'"
  [show]="displayNoLibertySettingPopover$ | async">
    <div class="flex flex-row-reverse">
        <app-button customClasses="px-4" [text]="'Ok'" class="save-btn" (click)="hideNoLibertySettingPopover()" [minWidth]="50">
        </app-button>
    </div>
</app-dialog>

<app-dialog *ngIf="displayLoadLibertyRxInventoryErrorModal$ | async"
  [showHeader]="true"
  header="Unable to Load inventory"
  subHeader="We are currently experiencing issues and are unable to load your inventory.  Please check back later."
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'warning'"
  [show]="true">
    <div class="flex flex-row-reverse">
        <app-button customClasses="px-4" [text]="'OK'" class="save-btn" [minWidth]="50" (click)="hideLoadInventoryErrorModal()">
        </app-button>
    </div>
</app-dialog>

<app-dialog *ngIf="displayLoadLibertyRxInventoryCancelModal$ | async"
  [showHeader]="true"
  header="Load inventory"
  subHeader="Loading cancelled."
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'info'"
  [show]="true">
    <div class="flex flex-row-reverse">
        <app-button customClasses="px-4" [text]="'OK'" class="save-btn" [minWidth]="50" (click)="hideLoadInventoryCancelModal()">
        </app-button>
    </div>
</app-dialog>

<app-order-details-dialog *ngIf="displayOrderDetailsDialog"
  [initialValue]="collectedOrderDetails"
  (canceled)="displayOrderDetailsDialog = false"
  (saved)="saveCollectedOrderDetails($event)"
>
</app-order-details-dialog>

<app-load-inventory-file-uploader-dialog *ngIf="displayFileUploader"
  (inventoryLoaded)="displayFileUploader = false; populateLoadedInventory($event)"
  (closeDialog)="displayFileUploader = false"
></app-load-inventory-file-uploader-dialog>